import { z } from 'zod';

export const ProvisioningMethodSchema = z.enum(['self_service', 'jsm']);

export type ProvisioningMethod = z.infer<typeof ProvisioningMethodSchema>;

/**
 * プロダクト情報 API レスポンスの Zod スキーマ
 * GET /api/products/:productId
 */
export const ProductResponseSchema = z.object({
  product_id: z.string(),
  product_name: z.string(),
  provisioning_method: ProvisioningMethodSchema,
  team: z.string(),
  budget: z.string(),
  purpose: z.string(),
  description: z.string(),
  jira_url: z.string(),
  confluence_url: z.string(),
  teams_url: z.string(),
  github_url: z.string(),
  phase_id: z.number(),
  latest_release_date: z.string(),
  latest_release_version: z.string(),
  next_release_date: z.string(),
  next_release_version: z.string(),
  create_date: z.string(),
  update_date: z.string(),
});

/** プロダクト API レスポンスの型 */
export type ProductResponse = z.infer<typeof ProductResponseSchema>;
